import React, { useState, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import { Typography, Box } from '@mui/material'

import { TextInput, PasswordInput, ThemeButton } from '../../../ui'
import { loginUser } from '../../../features/global'
import { AuthContext } from '../../../pages/auth'
import { useUserContext } from '../../../core/user'
import { PwdRecoveryMessageComponent } from '../../pwd-recovery'
import { useExtraComboFunctions } from '../../combos/hooks/combos.hook'

export const LoginFormComponent = () => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const { userDispatch } = useUserContext()
  const login = useContext(AuthContext)
  const { clearCombos } = useExtraComboFunctions()

  const [formState, setFormState] = useState({})
  const [loading, setLoading] = useState(false)
  const [errorMssg, setErrorMssg] = useState('')

  const handleChangeForm = (event) =>
    setFormState({ ...formState, [event.target.name]: event.target.value })

  const handleSubmitForm = (event) => {
    event.preventDefault()
    setLoading(true)
    login(formState)
      .then(({ data }) => {
        setLoading(false)
        clearCombos()
        dispatch(loginUser(data, userDispatch))
      })
      .catch(() => {
        setErrorMssg('Usuario o contraseña incorrecta')
        setLoading(false)
      })
  }

  return (
    <form onSubmit={handleSubmitForm}>
      <Box mb={4}>
        <Box mb={2}>
          <TextInput
            required
            value={formState['username']}
            name="username"
            title={formatMessage({ id: 'pages.login.form.field.user.title' })}
            placeholder={formatMessage({ id: 'pages.login.form.field.user.placeholder' })}
            onChange={handleChangeForm}
          />
        </Box>
        <Box mb={2}>
          <PasswordInput
            required
            value={formState['password']}
            name="password"
            title={formatMessage({ id: 'pages.login.form.field.password.title' })}
            placeholder={formatMessage({ id: 'pages.login.form.field.password.placeholder' })}
            onChange={handleChangeForm}
          />
        </Box>
        <PwdRecoveryMessageComponent />
      </Box>

      {errorMssg && (
        <Box mb={1}>
          <Typography variant="body2" color="error">
            {errorMssg}
          </Typography>
        </Box>
      )}
      <ThemeButton type="submit" fullWidth loading={loading}>
        {formatMessage({ id: 'pages.login.button.label' })}
      </ThemeButton>
    </form>
  )
}
